import { createContext, Dispatch, SetStateAction } from 'react';
import type { AnyProps, PointFeature } from 'supercluster';
import type { AirportType, FlightType, ViewportType } from './types';

export type ContextProps = {
  airportsData: Array<AirportType>;
  viewport: ViewportType;
  setViewport: Dispatch<SetStateAction<ViewportType>>;
  points: Array<PointFeature<AnyProps>>;
  setPoints: Dispatch<SetStateAction<Array<PointFeature<AnyProps>>>>;
  originAirport: AirportType | Record<string, never>;
  setOriginAirport: Dispatch<SetStateAction<AirportType | Record<string, never>>>;
  destinationAirport: AirportType | Record<string, never>;
  setDestinationAirport: Dispatch<SetStateAction<AirportType | Record<string, never>>>;
  flightType: FlightType;
  setFlightType: Dispatch<SetStateAction<FlightType>>;
  userLocation: GeolocationPosition | undefined;
  setUserLocation: Dispatch<SetStateAction<GeolocationPosition | undefined>>;
  userLocationError: boolean;
  setUserLocationError: Dispatch<SetStateAction<boolean>>;
  goToHawaii: boolean;
  setGoToHawaii: Dispatch<SetStateAction<boolean>>;
  isDesktop: boolean;
  mapboxKey: string;
  mapboxStyleUrl: string;
  mapFailed: boolean;
  setMapFailed: Dispatch<SetStateAction<boolean>>;
  nonstopChecked: boolean;
  setNonstopChecked: Dispatch<SetStateAction<boolean>>;
  showDisabledModal: boolean;
  setShowDisabledModal: Dispatch<SetStateAction<boolean>>;
  showDisabledModalConnection: boolean;
  setShowDisabledModalConnection: Dispatch<SetStateAction<boolean>>;
  hawaiiCount: Array<AirportType>;
};

const AppContext = createContext<ContextProps>({} as ContextProps);

export default AppContext;
